import service from "./service";

const getOrders = ({ page = 1, limit = 10, status = "all" } = {}) => {
  const query = new URLSearchParams({
    page: String(page),
    limit: String(limit),
  });

  if (status && status !== "all") {
    query.set("status", String(status).toLowerCase());
  }

  return service.get(`vendors/orders?${query.toString()}`);
};

const getOrder = (id) => service.get(`vendors/orders/${encodeURIComponent(id)}`);

const updateOrderStatus = (id, payload) =>
  service.put(`vendors/orders/${encodeURIComponent(id)}/status`, payload);

const respondToOrder = (id, payload) =>
  service.put(`vendors/orders/${encodeURIComponent(id)}/response`, payload);

export default { getOrders, getOrder, updateOrderStatus, respondToOrder };
